// Persistent save data via localStorage
const SAVE_KEY = 'knpplz.save.v1';

const DEFAULT_SAVE = {
  credits: 0,
  meta: {},
  highWave: 0,
  highTime: 0,
  totalKills: 0,
  runs: 0,
  bestCredits: 0,
};

export const Save = {
  load() {
    try {
      const raw = localStorage.getItem(SAVE_KEY);
      if (!raw) return JSON.parse(JSON.stringify(DEFAULT_SAVE));
      const parsed = JSON.parse(raw);
      return Object.assign({}, DEFAULT_SAVE, parsed, {
        meta: Object.assign({}, parsed.meta || {}),
      });
    } catch (e) {
      console.warn('save load failed', e);
      return JSON.parse(JSON.stringify(DEFAULT_SAVE));
    }
  },
  write(data) {
    try {
      localStorage.setItem(SAVE_KEY, JSON.stringify(data));
    } catch (e) {
      console.warn('save write failed', e);
    }
  },
  reset() {
    localStorage.removeItem(SAVE_KEY);
  },
};
